import React from 'react';
import Button from '@boschebike/ebds-react/dist-esm/components/Button.js';
import { IconAsChunk } from '@boschebike/ebds-react-icons';

/**
 * @typedef {import('../../App.d.ts').ButtonExtendedMapperInterface} ButtonExtendedMapperInterface
 */
/**
 *
 * @param {ButtonExtendedMapperInterface} props
 * @returns {Element}
 * @constructor
 */
export default (props) => (
  <Button
    data-testid="button"
    text={props.buttonText}
    srText={props.buttonSrText}
    mode={props.buttonMode}
    href={props.buttonHref}
    state={props.buttonState}
    isExternal={props.buttonExternal}
    icon={props.buttonIcon ? <IconAsChunk iconName={props.buttonIcon} /> : undefined}
    type="button"
  />
);
